// add-to-cart.js
export default (Alpine) => {
    Alpine.data("addToCart", (
        selectedVariantId,
    ) => ({
        selectedVariantId: selectedVariantId,
        selectedVariant: {},
        productObject: {},
        price: 0,
        description: '',
        image: '',
        sideCart: document.querySelector('side-cart'),
        selectLabel: document.querySelectorAll('.select-label'),
        selectDropdown: document.querySelectorAll('.select-dropdown'),

        
        init() {
            const raw = this.$refs.productObject.textContent.trim();
            this.productObject = JSON.parse(raw);
            console.log('this.productObject', this.productObject);
            this.selectedVariant = this.productObject.variants[String(this.selectedVariantId)];
            console.log('this.selectedVariant', this.selectedVariant);
            this.updateUi()
        },

        changeVariant(e) {
            if (e) {
                this.selectedVariantId = e.target.dataset.variantId;
            } else {
                this.selectedVariantId = this.$refs.variant.value;
            }
            this.selectedVariant = this.productObject.variants[String(this.selectedVariantId)];
            this.updateUi()
            this.updateLabel()
        },

        updateUi() {
            this.price = this.selectedVariant?.price;
            this.description = this.selectedVariant?.description;
            this.image = this.selectedVariant?.image || this.productObject.featured_image;
        },

        updateLabel() {
            this.selectLabel.forEach((label) => {
                label.setAttribute('for', this.selectedVariantId);
            });
            this.selectDropdown.forEach((dropdown) => {
                dropdown.setAttribute('id', this.selectedVariantId);
            });
        },

        addToCart(event) {
            event.preventDefault();
            
            const formData = {
                items: [
                    {
                        id: this.selectedVariantId,
                        quantity: 1,
                    },
                ],
            }
                    
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
            })
            .then(response => response.json())
            .then(() => {
                Rebuy.SmartCart.show()
            })
            .catch(error => {
                console.error('Error:', error);
            });

        },
    }));
  };